import axios from './request';
import {getValidationContent} from '../utils'
import { Log } from './log';
export const GetForumTypeList = (params) => {
  const { page, name } = params;
  const data = new FormData();
  data.append('page', page)
  data.append('name', name || '')
  data.append('num', 10)
  data.append('is_admin', 1)
  return axios.post('/section', data)
}


export const AddForumType = (params) => {
  const { name, synopsis, page_view, img, content, status, created_id } = params;
  const data = new FormData();
  data.append('type', 1)
  data.append('name', name)
  data.append('synopsis', synopsis)
  data.append('page_view', page_view)
  data.append('img', img[0] ? img[0].url : '/forum_base_img.png')
  data.append('content', content)
  data.append('status', status)
  data.append('created_id', created_id)
  Log(`添加了论坛版块${name}`)
  return axios.post('/section_operation', data)
}

export const EditForumType = (params) => {
  const { name, synopsis, page_view, img, content, status, id } = params;

  const data = new FormData();
  data.append('type', 2)
  data.append('name', name)
  data.append('synopsis', synopsis)
  data.append('id', id)
  data.append('page_view', page_view)
  data.append('img', img[0] ? img[0].url : '')
  data.append('content', content)
  data.append('status', status)
  Log(`修改了论坛版块${name},id为${id}`)
  return axios.post('/section_operation', data)
}

export const DeleteForumType = (params) => {
  const { id } = params;
  const data = new FormData();
  data.append('type', 3)
  data.append('id', id)
  Log(`删除了论坛版块${id}`)
  return axios.post('/section_operation', data)
}


export const ShowHideForumType = (params) => {
  const { id, status } = params;
  const data = new FormData();
  data.append('type', 2)
  data.append('id', id)
  data.append('status', status)
  Log(`${status == 1 ? '显示' : '隐藏'}了论坛版块${id}`)
  return axios.post('/section_operation', data)
}

export const GetAdminForumList = (params) => {
  const { page, title } = params;
  const data = new FormData();
  data.append('page', page)
  data.append('title', title)
  data.append('sid', '')
  data.append('uid', '')
  data.append('show_like', '')
  return axios.post('/topic_list_admin', data)
}

export const AddTopic = (params) => {
  const { sid, content, status, created_id, title } = params;
  const data = new FormData();
  data.append('type', 1)
  data.append('title', title)
  data.append('content', content)
  data.append('status', status)
  data.append('created_id', created_id)
  data.append('sid', sid)
  const {validateImgs,validateVideos,validateContent} = getValidationContent(content);
  data.append('validateImgs', validateImgs || '')
  data.append('validateVideos', validateVideos || '')
  data.append('validateContent', validateContent || '')
  Log(`添加了帖子${title}`)
  return axios.post('/topic_operation', data)
}

export const EditTopic = (params) => {
  const { sid, content, status, id, title } = params;
  const data = new FormData();
  data.append('type', 2)
  data.append('title', title)
  data.append('id', id)
  data.append('content', content)
  data.append('sid', sid)
  data.append('status', status)
  const {validateImgs,validateVideos,validateContent} = getValidationContent(content);
  data.append('validateImgs', validateImgs || '')
  data.append('validateVideos', validateVideos || '')
  data.append('validateContent', validateContent || '')
  Log(`修改了帖子${title},id为${id}`)
  return axios.post('/topic_operation', data)
}

export const DeleteTopic = (params) => {
  const { id } = params;
  const data = new FormData();
  data.append('type', 3)
  data.append('id', id)
  Log(`删除了帖子,id为${id}`)
  return axios.post('/topic_operation', data)
}


export const ShowHideTopic = (params) => {
  const { id, status } = params;
  const data = new FormData();
  data.append('id', id)
  data.append('status', status)
  Log(`${status == 1 ? '显示' : '隐藏'}了帖子${id}`)
  return axios.post('/up_ststus', data)
}



// WEBPACK FOOTER //
// ./src/request/adminForum.js